import { ChatFilters, STATUS } from '../../search-and-filter-schema/protected';
export const DEFAULT_CHAT_FILTERS = ChatFilters({
  [STATUS]: null
});